import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_CONSTRAINT} from '../../metamodel/Concept';

export default class ConstraintNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_CONSTRAINT;
	}
}
